<!-- Presentational component for displaying a price, possibly with a discount -->
<template>
	<div
		v-if="priceDetails"
		class="flex text-slate-500"
		:class="{
			'text-sm': size === 'sm',
			'text-xs': size === 'xs',
		}"
	>
		<!-- Crossed-out original price -->
		<span
			class="text-secondary-300! mr-2 line-through"
			v-if="
				priceDetails.originalPrice &&
				priceDetails.originalPrice > priceDetails.price
			"
		>
			{{ formatPrice(priceDetails.originalPrice) }}
		</span>

		<!-- Price and quantity -->
		<div
			class="flex flex-col items-end justify-center text-slate-500"
			:class="{
				'text-secondary-300! line-through': deleted,
				'text-accent-600!': priceDetails.price < 0 && !deleted,
			}"
		>
			<span v-if="isPackage">
				{{ priceDetails.price ? formatPrice(priceDetails.price) : '' }}
			</span>
			<span v-else-if="priceDetails.price === 0">{{
				t('reviewSlide.included')
			}}</span>
			<span v-else-if="credit">{{ creditString }}</span>
			<span v-else>{{ formatPrice(priceDetails.price) }}</span>

			<span
				class="text-slate-40 text-xs leading-tight font-bold tracking-tight"
				v-if="priceDetails.quantity && priceDetails.quantity > 1"
			>
				{{ t('merchandise.quantity') }} {{ priceDetails.quantity }}</span
			>
		</div>
	</div>
</template>

<script setup lang="ts">
import { usePresentationLocale } from '@/i18n'
import { useMerchandise, type PricingDetails } from '@/mixins/merchandise'
import { type PropType, computed } from 'vue'

const { formatPrice } = useMerchandise()
const { t } = usePresentationLocale()

const props = defineProps({
	priceDetails: Object as PropType<
		Pick<PricingDetails, 'price' | 'originalPrice' | 'quantity'>
	>,
	deleted: Boolean,
	credit: Boolean,
	isPackage: Boolean,
	size: {
		type: String,
		default: 'sm',
		options: ['sm', 'xs'],
	},
})

const creditString = computed(() => {
	if (!props.priceDetails) return ''

	return t('merchandise.credit', {
		amount: formatPrice(props.priceDetails.price),
	})
})
</script>
